import React from "react"
import { connect } from "react-redux"
import {
  message,
  Select,
  Radio,
  Pagination,
  Input,
  Tooltip,
  Popconfirm,
} from "antd"
import { Modal } from "react-bootstrap"
import CreatePermissionForm from "./createPermissionForm"
import SweetAlert from "react-bootstrap-sweetalert"
import {
  Card,
  CardBody,
  CardFooter,
  Col,
  UncontrolledTooltip,
  Collapse,
  PopoverBody,
  PopoverHeader,
  Button,
  Table,
  Badge,
  Row,
  CardTitle,
  CardImg,
  CardText,
  Popover,
  ButtonToolbar,
  CardHeader,
} from "reactstrap"
//import PopConfirm from 'react-popconfirm'
import { CopyToClipboard } from "react-copy-to-clipboard"
import Chips from "../../components/CommonFilter/chips"
import moment from "moment"
import {
  getPermissions,
  upsertPermission,
  deletePermission,
  resetState,
} from "appRedux/slices/permissions"
import QueryString from "query-string"
import ErrorBoundComponent from "../../components/ErrorBoundComponent"
import Auxiliary from "../../util/Auxiliary"
import _ from "lodash"
//import "./stickers.style.css"
// const { Meta } = Card
const { Option } = Select
import { withRouter } from "react-router-dom"
import toastr from "toastr"
import { NO_PERMISSION_MESSAGE } from "../../constants/uiConstants"

class BrowsePermissions extends ErrorBoundComponent {
  state = {
    showTrendingForm: false,
    showFilters: false,
    stickerId: "",
    popoverbottom: false,
    filters: {
      pageSize: 10,
      currentPage: this.props.queryParams
        ? this.props.queryParams["currentPage"]
        : 1,
      mimeType: this.props.queryParams
        ? this.props.queryParams["mimeType"]
        : "animatedsticker",
      isActive: this.props.queryParams
        ? this.props.queryParams["isActive"]
        : true,
      name: this.props.queryParams ? this.props.queryParams["name"] : "",
      selectedFilter: this.props.queryParams
        ? this.props.queryParams["selectedFilter"]
        : "CAMERA",
    },
    showUpsertModal: false,
    stickerAsset: {},
    selectedFilter: "CAMERA",
  }

  componentDidMount() {
    const { filters } = this.state
    if (!this.props.common.error) {
      this.props.dispatch(getPermissions())
    }
    window.addEventListener("keydown", this._keyDownHandler)
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.refetchData &&
      !this.props.common.error &&
      prevProps.refetchData !== this.props.refetchData
    ) {
      this.props.dispatch(getPermissions())
    }
  }

  componentWillUnmount() {
    this.props.dispatch(resetState())
    window.removeEventListener("keydown", this._keyDownHandler)
  }

  _keyDownHandler = ({ key }) => {
    if (key === "Enter" && this.state.showFilters === true) {
      return this._searchStickers()
    }
    if (key === "Escape" && this.state.showFilters === true) {
      this.setState({
        showFilters: false,
        showAdvancedFilters: false,
      })
    }
  }

  _closeUpsertModal = () => {
    this.setState({
      showUpsertModal: false,
      formAction: "create",
      stickerAsset: {},
    })
  }

  _onCreateStickerAsset = () => {
    const hasEditPermission =
      this.props.currentUser &&
      this.props.currentUser.permissions &&
      this.props.currentUser.permissions.includes("EDIT_MANAGE_STICKERS")
    if (!hasEditPermission) {
      return toastr.error(NO_PERMISSION_MESSAGE)
    }
    this.setState({
      showUpsertModal: true,
      formAction: "create",
      stickerAsset: {},
    })
  }

  _onUpsert = async formData => {
    let data = {
      formData,
      query: {
        action: this.state.formAction,
        appCode: this.props.appCode,
        permissionId: this.state.permissionData?.permissionId || "",
      },
    }
    //data.userType = formData.jotUserType % 10
    this._onModalCancel()
    this.props.dispatch(upsertPermission(data))
  }

  _getPermissionUpsertForm = () => {
    if (
      this.state.formAction === "create" ||
      this.state.formAction === "update"
    ) {
      return (
        <CreatePermissionForm
          onSubmit={this._onUpsert}
          appCode={this.state.appCode}
          data={this.state.permissionData}
          formAction={this.state.formAction}
          userId={this.state.userId}
          currentUser={this.props.currentUser}
          permissionList={this.props.permissionList}
          roleData={this.props.rolesList}
          // agencyList={this.props.agencyList}
          onCancel={() =>
            this.setState({ showModal: false, permissionData: {} })
          }
        />
      )
    }
  }

  _onModalCancel = () => {
    this.setState({
      showForm: false,
      showModal: false,
      permissionData: {},
    })
  }

  _modal = () => {
    return (
      <Modal
        show={this.state.showModal}
        onHide={this._onModalCancel}
        footer={null}
        fullscreen={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="modalTitle">{"Permission"}</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>{this._getPermissionUpsertForm()}</Row>
        </Modal.Body>
      </Modal>
    )
  }

  _onEditTabAsset = (e, stickerAsset) => {
    e.preventDefault()
    e.stopPropagation()
    const hasEditPermission =
      this.props.currentUser &&
      this.props.currentUser.permissions &&
      this.props.currentUser.permissions.includes("EDIT_MANAGE_STICKERS")
    if (!hasEditPermission) {
      return toastr.error(NO_PERMISSION_MESSAGE)
    }
    this.setState({
      showUpsertModal: true,
      formAction: "update",
      stickerAsset: stickerAsset,
    })
  }

  _onDeletePermissionById = (e, id) => {
    e.preventDefault()
    e.stopPropagation()
    // const hasEditPermission =
    //     this.props.currentUser &&
    //     this.props.currentUser.permissions &&
    //     this.props.currentUser.permissions.includes("EDIT_MANAGE_STICKERS")
    // if (!hasEditPermission) {
    //     return toastr.error(NO_PERMISSION_MESSAGE)
    // }

    this.props.dispatch(
      deletePermission({
        id: id,
      })
    )
  }

  _onStickerSubmit = formData => {
    const data = {
      formData,
      query: {
        action: this.state.formAction,
        selectedFilter: this.state.filters["selectedFilter"],
        tabId: this.state.stickerAsset.stickerId,
      },
    }
    //this.props.dispatch(upsertSticker(data))
  }

  //   _getModalContent = () => {
  //     return (
  //       <UpsertStickersForm
  //         formAction={this.state.formAction}
  //         stickerAsset={this.state.stickerAsset}
  //         stickersFor={this.state.filters["selectedFilter"]}
  //         onSubmit={this._onStickerSubmit}
  //         onCancel={this._closeUpsertModal}
  //       />
  //     )
  //   }

  _closeModal = () => {
    this.setState({
      showModal: false,
      audioId: null,
      defaultValue: null,
    })
  }

  // _modal = () => {
  //     return (
  //         <Card>
  //             <CardTitle className="p-3 pb-0">{"Create/Edit Stickers"}</CardTitle>
  //             <CardBody style={{ maxHeight: "75vh", overflowY: "auto" }}>
  //                 {this._getModalContent()}
  //             </CardBody>
  //         </Card>
  //     )
  // }

  _handleFieldChange = (value, type) => {
    const newFilters = _.cloneDeep(this.state.filters)
    newFilters[type] = value
    this.setState({
      filters: newFilters,
    })
    if (type === "selectedFilter") {
      //this.props.dispatch(getMimeTypes({ selectedFilter: value }))
      this.setState({
        selectedFilter: value,
      })
    }
  }

  _searchStickers = () => {
    this.props.history.push(
      `/stickers/manage?${QueryString.stringify(
        _.deepClean(this.state.filters)
      )}`
    )
    this.setState({
      showFilters: false,
      showAdvancedFilters: false,
    })
  }

  _toggleFilters = () => {
    this.setState({
      showFilters: !this.state.showFilters,
    })
  }

  _removeFilter = filter => {
    const newFilters = {
      ...this.state.filters,
      [filter]: stickersForSearchAndSelectFilters[filter].defaultValue,
    }

    this.setState(
      {
        filters: newFilters,
      },
      () => {
        this.props.history.push(
          `/stickers/manage?${QueryString.stringify(
            _.deepClean(this.state.filters)
          )}`
        )
      }
    )
  }

  _actionButtons = () => {
    return (
      <div>
        <Row className="actions-buttons" gutter={24}>
          <Col span={6}>
            <div className="d-flex justify-content-end mb-2 mx-4">
              <Button
                color="primary"
                onClick={() => {
                  this.setState(
                    {
                      showModal: false,
                    },
                    () =>
                      this.setState({
                        formAction: "create",
                        showModal: true,
                        permissionData: {},
                      })
                  )
                }}
              >
                Create
              </Button>
            </div>
          </Col>
          {/* <Col span={4}>
            <Select
              allowClear={true}
              placeholder="Is Active"
              onChange={value => {
                this._handleFieldChange(value, "isActive")
              }}
              defaultValue={
                this.state.filters["isActive"]
                  ? this.state.filters["isActive"]
                  : "True"
              }
              style={{ width: "100%" }}
            >
              <Option value="true">True</Option>
              <Option value="false">False</Option>
            </Select>
          </Col>
          <Col span={4}>
            <Select
              style={{ width: "100%" }}
              allowClear={true}
              label="Mime Type"
              placeholderLabel="Mime Type"
              className="creator-form"
              onChange={value => this._handleFieldChange(value, "mimeType")}
              defaultValue={this.state.filters["mimeType"]}
              options={this.props.mimeTypes.map(mime => ({
                label: mime,
                value: mime,
              }))}
            />
          </Col>
          <Col span={6}>
            <Input.Group>
              <Input
                defaultValue={this.state.filters["name"]}
                placeholder={"Sticker Name"}
                onChange={e => this._handleFieldChange(e.target.value, "name")}
                allowClear={true}
                name="name"
                style={{ width: "100%" }}
              />
            </Input.Group>
          </Col> */}
          {/* <Row>
            <Col span={22}>
              <Chips
                mimeTypes={this.props.mimeTypes}
                showFilters={this.state.showFilters}
                filters={this.state.filters}
                search={this._searchStickers}
                removeFilter={this._removeFilter}
                handleFilterChange={this._handleFieldChange}
                type="stickerForSearchAndSelect"
                toggleFilters={this._toggleFilters}
              />
            </Col>
          </Row> */}
        </Row>
      </div>
    )
  }

  _tabsList = () => {
    const { permissionList = [] } = this.props
    return (
      <Row>
        {permissionList.map(tab => (
          <Col lg="3" sm="6" md="4">
            <Card className="overflow-hidden shadow-lg">
              <CardHeader className="d-flex justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="font-size-16" style={{ fontWeight: "600" }}>
                    {tab.permissionName}
                  </div>
                  <div>
                    <Badge
                      className={
                        tab.status === "active"
                          ? "badge-soft-success ms-1 rounded-pill px-3"
                          : "badge-soft-warning ms-1 rounded-pill px-3"
                      }
                    >
                      <div className="font-size-12 p-1">
                        {tab.status === "active" ? "Active" : "Disabled"}
                      </div>
                    </Badge>
                  </div>
                </div>
                {/* <div style={{ color: "chocolate" }}>
                                    <Popconfirm
                                        placement="bottomRight"
                                        title="Are you sure you want to delete this Permission?"
                                        onConfirm={e => {
                                            this._onDeletePermissionById(e, tab.permissionId)
                                        }}
                                    >
                                        <i className="bx bx bx-trash-alt font-size-16 fw-bold" role="button" />
                                    </Popconfirm>
                                </div> */}
              </CardHeader>
              <CardBody
                className="d-flex flex-column justify-content-evenly"
                style={{ height: "120px" }}
              >
                {tab.createdBy && (
                  <div className="p-1 font-size-16">
                    <i
                      className="bx bx-user-circle font-size-16 pe-1"
                      style={{ color: "#09d493" }}
                    />
                    <span>Created By: </span>
                    <span className="fw-bold">{tab.createdBy}</span>
                  </div>
                )}
                {tab.createdOn && (
                  <div className="p-1 font-size-16">
                    <i
                      className="bx bx-calendar font-size-16 pe-1"
                      style={{ color: "#60bfd3" }}
                    />
                    <span>Created On: </span>
                    <span className="fw-bold">
                      {moment(tab.createdOn).format("DD MMM YYYY")}
                    </span>
                  </div>
                )}
              </CardBody>
              <CardFooter>
                <div className="text-sm-end" style={{ paddingBottom: "15px" }}>
                  <Button
                    color="light"
                    className="font-16 btn-block btn btn-light"
                    onClick={() => {
                      // if (
                      //   !this.props.currentUser?.permissions?.includes(
                      //     "EDIT_MANAGE_CMS_USER"
                      //   )
                      // ) {
                      //   toastr.error(NO_PERMISSION_MESSAGE)
                      //   return
                      // }
                      this.setState(
                        {
                          showModal: false,
                        },
                        () =>
                          this.setState({
                            formAction: "update",
                            showModal: true,
                            permissionData: tab,
                          })
                      )
                    }}
                  >
                    <i className="bx bx-edit-alt me-1" />
                    Edit
                  </Button>
                </div>
              </CardFooter>
            </Card>
          </Col>
        ))}
      </Row>
    )
  }

  _onPageChange = value => {
    this.setState({ loading: true })
    let newFilters = _.cloneDeep(this.state.filters)
    newFilters["currentPage"] = value
    this.setState(
      {
        filters: newFilters,
      },
      () => {
        this._searchContent()
      }
    )
  }

  _searchContent = () => {
    this.props.history.push(
      `/stickers/manage?${QueryString.stringify(
        _.deepClean(this.state.filters)
      )}`
    )
  }

  render() {
    return (
      <Auxiliary
        loading={this.props.loading}
        error={_.get(this.props, "common.error")}
      >
        {!this.state.showTrendingForm &&
          !this.state.showUpsertModal &&
          this._actionButtons()}
        {this.state.showModal && this._modal()}
        {!this.state.showTrendingForm &&
          !this.state.showUpsertModal &&
          this._tabsList()}
        {this.state.showTrendingForm &&
          !this.state.showUpsertModal &&
          this._trendingForm()}
        {!this.state.showTrendingForm && !this.state.showUpsertModal && (
          <div className="d-flex justify-content-end">
            <Pagination
              style={{ marginTop: "1rem" }}
              onChange={this._onPageChange}
              defaultCurrent={this.state.filters.currentPage}
              total={
                this.props.stickersList && this.props.stickersList.total
                  ? this.props.stickersList.total
                  : 1
              }
              pageSize={this.state.filters["pageSize"] || "12"}
              showSizeChanger={false}
            />
          </div>
        )}
      </Auxiliary>
    )
  }
}
function mapStateToProps(store, ownProps) {
  return {
    //stickersTabList: _.get(store, "stickers.stickersTabList"),
    permissionList: _.get(store, "permissions.permissionList"),
    //stickersList: _.get(store, "stickers.stickersList"),
    refetchData: _.get(store, "permissions.refetchData"),
    loading: _.get(store, "permissions.permissionLoading"),
    queryParams: _.get(ownProps, "location.search")
      ? QueryString.parseUrl(_.get(ownProps, "location.search")).query
      : undefined,
    common: _.get(store, "common"),
    appCode: _.get(store, "application.appCode"),
    currentUser: _.get(store, "currentUser.currentUser.data"),
  }
}

export default connect(mapStateToProps)(BrowsePermissions)
